
const TTL_MS = 5 * 60 * 1000;

/** @type {Map<string, { data: any, expiry: number }>} */
const store = new Map();
/** @type {Map<string, Promise<any>>} */
const inflight = new Map();

/**
 * Returns cached data if fresh, deduplicates concurrent callers, otherwise fetches.
 * @template T
 * @param {string} key
 * @param {() => Promise<T>} fetcher
 * @returns {Promise<T>}
 */
export function cached(key, fetcher) {
  const now = Date.now();
  const hit = store.get(key);
  if (hit && hit.expiry > now) {
    return Promise.resolve(hit.data);
  }
  if (inflight.has(key)) {
    return inflight.get(key);
  }
  const promise = Promise.resolve()
    .then(fetcher)
    .then((data) => {
      store.set(key, { data, expiry: Date.now() + TTL_MS });
      inflight.delete(key);
      return data;
    })
    .catch((err) => {
      inflight.delete(key);
      throw err;
    });
  inflight.set(key, promise);
  return promise;
}

/** @param {...string} keys */
export function invalidate(...keys) {
  keys.forEach((k) => {
    store.delete(k);
    inflight.delete(k);
  });
}

export function invalidateAll() {
  store.clear();
  inflight.clear();
}

// Clear everything when the session expires so stale data is never served post-login.
if (typeof window !== "undefined") {
  window.addEventListener("ecogynize:auth-expired", invalidateAll);
}
